import React from 'react';
import ModalOuterContainer from '../../generic/containers/ModalOuterContainer';
import Button from 'components/shared/generic/button/presentational/Button';
import SectionTitle from 'components/shared/generic/sectionTitle/presentational/SectionTitle';
import CurrencyModalItem from 'components/shared/layout/currencyModalItem/presentational/CurrencyModalItem';
import ButtonContainer from 'components/shared/generic/buttonContainer/presentational/ButtonContainer';
import Typography from 'components/shared/generic/typography/presentational/Typography';

export interface SearchCurrencyListItem {
    name: string;
    currency_code: string;
}

export interface SearchAndListModalProps {
    popularList: SearchCurrencyListItem[];
    othersList: SearchCurrencyListItem[];
    result: SearchCurrencyListItem[];
    searchTerm?: string;
    handleClick: (item: SearchCurrencyListItem) => void;
    handleCloseModal: (event: React.MouseEvent<HTMLButtonElement>) => void;
    handleSearchTerm: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const SearchAndListModal = ({
    handleCloseModal,
    handleClick,
    searchTerm,
    handleSearchTerm,
    result,
    popularList,
    othersList,
}: SearchAndListModalProps) => {
    return (
        <ModalOuterContainer customButtons={true}>
            <div className="description search-and-list">
                <SectionTitle title="Choose Currency" />
                <div className="search-input-container">
                    <i className="fas fa-search" />
                    <input
                        type="text"
                        placeholder="Search"
                        onChange={handleSearchTerm}
                        value={searchTerm}
                    />
                </div>
                <div className="search-and-list-container">
                    {!searchTerm ? (
                        <>
                            <div className="search-list-container">
                                <Typography tag="h3">Popular</Typography>
                                <div>
                                    {popularList.map(item => (
                                        <option
                                            key={`${item.name}-${item.currency_code}-popular`}
                                            onClick={() => handleClick(item)}
                                            className="search-and-list-item-container"
                                        >
                                            <CurrencyModalItem item={item} />
                                        </option>
                                    ))}
                                </div>
                            </div>
                            <div className="search-list-container">
                                <Typography tag="h3">Others</Typography>
                                <div>
                                    {othersList.map(item => (
                                        <option
                                            key={`${item.name}-${item.currency_code}-others`}
                                            onClick={() => handleClick(item)}
                                            className="search-and-list-item-container"
                                        >
                                            <CurrencyModalItem item={item} />
                                        </option>
                                    ))}
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="search-list-container">
                            <Typography tag="h3">Result</Typography>
                            {searchTerm && result.length ? (
                                <div>
                                    {result.map(item => (
                                        <option
                                            key={`${item.name}-${item.currency_code}-result`}
                                            onClick={() => handleClick(item)}
                                            className="search-and-list-item-container"
                                        >
                                            <CurrencyModalItem item={item} />
                                        </option>
                                    ))}
                                </div>
                            ) : (
                                <Typography className="results-errors">
                                    No results could be found
                                </Typography>
                            )}
                        </div>
                    )}
                </div>
            </div>
            <ButtonContainer>
                <Button className="cancel" onClick={handleCloseModal}>
                    Cancel
                </Button>
            </ButtonContainer>
        </ModalOuterContainer>
    );
};

export default SearchAndListModal;
